import { Controller, Toolbar } from '@tencent/workbench';
import { ExitMasterEditFeature } from './exit-master-edit-feature';
import { TOOLBAR_CONFIGS, config } from './config';

@Controller({
    toolbarItems: TOOLBAR_CONFIGS,
})
export class ExitMasterEditController {
    constructor(private readonly feature: ExitMasterEditFeature) {}

    @Toolbar(config.id, 'onClick')
    public onClick() {
        this.feature.exitMasterEdit();
    }

    @Toolbar(config.id, 'shouldHide')
    public shouldHide() {
        return !(this.feature.curModelIsLayout || this.feature.curModelIsMaster);
    }
}
